import { Grid } from '@mui/material'
import styled from 'styled-components'

export const DashboardMainGrid = styled(Grid).attrs(() => ({
  container: true,
  spacing: { xs: '6px', sm: 1, md: 2 },
}))(({ theme }) => ({}))
